export default "<div class=\"floating-help-button\"></div>\n"